import {Component, OnInit} from "@angular/core";
import {Report} from "../../shared/models/report";
import {Observable} from "rxjs";
import {SearchConfiguration} from "../../shared/components/data-table/data-table.component";
import {DataStoreService} from "../../shared/services/api/data-store.service";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";
import {AppointmentCreateComponent} from '../../appointment/appointment-create/appointment-create.component';
import {Appointment} from '../../shared/models/appointment';
import * as moment from "moment";
import {MatDialog} from "@angular/material";

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css']
})
export class ReportListComponent implements OnInit {

  reports: Report[] | Observable<Report[]> = null;

  private static cachedReports: Report[] = null;
  filterForm: FormGroup;

  filters: Observable<any>;

  model = Report;

  private searchConfiguration: SearchConfiguration<Report> = {
    idField: "id",
    fields: [
      {name: "subject", boost: 30},
      {name: "description", boost: 5}
    ]
  };

  constructor(private dataStore: DataStoreService,
              private formBuilder: FormBuilder,
              private dialog: MatDialog,
              public router: Router) {
    this.filterForm = this.formBuilder.group({
      "important": [false],
      "todo": [false],
    })
    this.filters = this.filterForm.valueChanges.map(formValue => Object.keys(formValue).filter(key => formValue[key]).reduce((prev, curr) => {
        prev[curr] = true;
        return prev
      }, {}
    ));
  }

  ngOnInit() {
  }


  createReport() {
    let dialogRef = this.dialog.open(AppointmentCreateComponent, {
      data: {
        day: moment(),
      }
    });
    dialogRef.afterClosed().subscribe((appointment: Appointment) => {
      if (appointment != null && appointment.id) {
        this.router.navigate(["/appointment", appointment.id, "report"])
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/report/report-list/report-list.component.ts